import { apiRequest } from "util/services";

const FEEDBACK_BASE = "feedback";

/**
 * @typedef {Object} SalesHandoffPayload
 * @property {string} [visitorId]
 * @property {string} [email]
 * @property {string} [intent]
 * @property {string} [friction]
 * @property {string} [summary]
 * @property {string} [destination]
 */

export async function sendSalesHandoff(botId, sessionId, payload) {
  const res = await apiRequest(
    `${FEEDBACK_BASE}/instruments/${botId}/sessions/${sessionId}/sales-handoff`,
    "POST",
    payload,
    true,
  );
  if (res?.cancel) throw new Error("CANCELLED");
  if (res?.error || res?.error_code || !res?.ok) {
    throw new Error(res?.error_code || res?.error || "handoff_failed");
  }
  return res.handoff;
}

export async function fetchSalesHandoffRules(botId) {
  const res = await apiRequest(
    `${FEEDBACK_BASE}/instruments/${botId}/sales-handoff-rules`,
    "GET",
    null,
    true,
  );
  if (res?.cancel) throw new Error("CANCELLED");
  if (res?.error || res?.error_code) {
    throw new Error(res?.error_code || res?.error);
  }
  return {
    rules: res?.rules || [],
    simulated: Boolean(res?.simulated),
  };
}

export async function saveSalesHandoffRule(botId, rule) {
  const res = await apiRequest(
    `${FEEDBACK_BASE}/instruments/${botId}/sales-handoff-rules`,
    "POST",
    rule,
    true,
  );
  if (res?.cancel) throw new Error("CANCELLED");
  if (res?.error || res?.error_code || !res?.ok) {
    throw new Error(res?.error_code || res?.error || "rule_save_failed");
  }
  return res;
}

export function buildHandoffSummaryFromSession(detail, messages = []) {
  const userLines = messages
    .filter((m) => m.role === "user")
    .map((m) => m.content)
    .filter(Boolean)
    .slice(0, 3);
  const snippet = userLines.join(" ").slice(0, 280);
  return (
    snippet ||
    detail?.lead?.notes ||
    "Visitor showed purchase intent during the conversation."
  );
}

export async function fetchSalesAvailability() {
  const res = await apiRequest(`${FEEDBACK_BASE}/prospect/sales-availability`, "GET", null, true);
  if (res?.cancel) throw new Error("CANCELLED");
  if (res?.error || res?.error_code) throw new Error(res?.error_code || res?.error);
  return res;
}

export async function updateSalesAvailability(payload) {
  const res = await apiRequest(`${FEEDBACK_BASE}/prospect/sales-availability`, "POST", payload, true);
  if (res?.cancel) throw new Error("CANCELLED");
  if (res?.error || res?.error_code) throw new Error(res?.error_code || res?.error || "availability_failed");
  return res;
}
